"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScriptLoader = getScriptLoader;
exports.loadScript = loadScript;
var _constants = require("../constants");
var _log = require("./log");
/**
 * @param appName Application name / logger key.
 * @returns Loading script asynchronous function.
 */
function getScriptLoader(appName) {
  return async (scriptUrl, scriptId) => loadScript(scriptUrl, scriptId, appName);
}

// Each script has own loading promise with unique ID in this map.
const scripts = new Map();
async function loadScript(scriptUrl, scriptId, appName) {
  const logDebug = (0, _log.getDebugLogger)(appName ?? _constants.APP_NAME);
  let promise = scripts.get(scriptId);
  if (promise) {
    return promise;
  }
  promise = new Promise((resolve, reject) => {
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'text/javascript';
      script.async = true;
      script.src = scriptUrl;
      script.addEventListener('load', () => resolve());
      script.addEventListener('error', error => reject(error.error));
      logDebug(`Adding script with ID ${scriptId} ...`);
      document.body.append(script);
    }
  });
  scripts.set(scriptId, promise);
  return promise;
}
//# sourceMappingURL=loadScript.js.map